import { defineComponent as _defineComponent } from 'vue';
import { SButton, SIcon } from '@strana-artw/ui-kit';
import { defineComponent, onBeforeMount, ref } from 'vue';
import { scrollTo } from '@/shared/lib/utils/scroll';
export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollUpButton',
  setup: function setup(__props) {
    defineComponent({
      name: 'ScrollUpButton'
    });
    onBeforeMount(function () {
      window.addEventListener('scroll', handleScroll, {
        passive: true
      });
    });
    var toggle = ref(false);
    function handleScroll() {
      toggle.value = window.scrollY > 200;
    }
    return {
      __sfc: true,
      toggle: toggle,
      handleScroll: handleScroll,
      SButton: SButton,
      SIcon: SIcon,
      scrollTo: scrollTo
    };
  }
});